export enum Datalayer {
  EVENT_CUADRO_ALERTA = 'Cuadro Alerta Pagos',
  CATEGORIA_TRANSVERSAL = 'Alerta transversal',
  MENSAJE_INTERNO = 'mensaje-interno',
  CODIGO_ERROR = 'codigo-error',
  ID_PAGO = 'id-pago',
  ID_REQUEST = 'id-request',
  DEFAULT_ERROR_CODE = '0000',
  DEFAULT_ERROR_CODE_SERVICIO_INDISPONIBLE = '503',
  DEFAULT_MENSAJE_INTERNO = 'No aplica',
}
